export default '.15s ease-in-out';
